import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCostCentersList } from '../http/cost-centers';
import { CostCentersParams } from '../interfaces/filterParams.interface';
import { CostCenterDto } from 'desk-common';

export const useCostCenters = (
  filters: CostCentersParams,
  options?: Omit<
    UseQueryOptions<
      CostCenterDto[],
      Error,
      CostCenterDto[],
      readonly [string, CostCentersParams]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['cost-centers', filters],
    queryFn: getCostCentersList,
    ...options,
  });
};
